<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="timeRanges"
      :items="timeRanges"
      :fields="timeRangesFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedTimeRanges"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      timeRangesFields: [
        {key: 'tr_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'range', label: this.$i18n.t('Ranges'), sortable: true},
        {key: 'priority', label: this.$i18n.t('Priority'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedTimeRanges: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedTimeRanges = {
        slices: [],
        days: [],
        name: '',
        priority: 0,
        tr_id: 0
      }
      this.$root.$emit('bv::show::modal', 'modalEditTimeRanges', '#btnShow')
    },
    editItem (item) {
      this.selectedTimeRanges = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditTimeRanges', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Time ranges"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Tariffing/DELETE_TIME_RANGE', item.tr_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TIME_RANGE')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    timeRanges () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TIME_RANGE']))
      let num = 0
      let numDays = 0
      for (let el of copy) {
        el.range = ''
        for (let elSlices of el.slices) {
          elSlices.num = ++num
          el.range += elSlices.start_wday +
          ' - ' + elSlices.end_wday + ' ' + elSlices.start_hour +
          ':' + elSlices.start_min + ':' + elSlices.start_sec +
          ' - ' + elSlices.end_hour + ':' + elSlices.end_min +
          ':' + elSlices.end_sec + '; '
        }
        for (let elDays of el.days) {
          elDays.num = ++numDays
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_TIME_RANGE')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/other/timeRanges/main.vue